import { Alert, AlertTitle } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

type CalloutKind = 'info' | 'tip' | 'warning' | 'danger';

const SEVERITY = {
  info: 'info',
  tip: 'success',
  warning: 'warning',
  danger: 'error',
} as const;

/** Boxed aside for asides/tips/warnings inside prose. */
export const Callout: React.FC<{
  kind?: CalloutKind;
  title?: string;
  children?: React.ReactNode;
}> = ({ kind = 'info', title, children }) => (
  <Alert severity={SEVERITY[kind]} variant="outlined" sx={{ my: 3 }}>
    {title && <AlertTitle>{title}</AlertTitle>}
    {children}
  </Alert>
);

/**
 * Pull-quote / margin note. styled() because it's a reused structural block
 * with a themed accent border, not a one-off value.
 */
export const Aside = styled('aside')(({ theme }) => ({
  margin: theme.spacing(4, 0),
  paddingLeft: theme.spacing(3),
  borderLeft: `4px solid ${theme.palette.primary.main}`,
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
  fontSize: '1.15rem',
  lineHeight: 1.6,
}));
